import React, { forwardRef, useState } from "react";
import { TextInput, TextInputProps } from "react-native";

export type FormInputProps = TextInputProps & {
  error?: string;
};

export const FormInput = forwardRef<TextInput, FormInputProps>(
  (
    { className = "", error, onFocus, onBlur, placeholderTextColor, ...rest },
    ref,
  ) => {
    const [focused, setFocused] = useState(false);

    const stateClasses = error
      ? "bg-white border-red-500"
      : focused
      ? "bg-white border-blue-500"
      : "bg-gray-50 border-gray-100";

    return (
      <TextInput
        ref={ref}
        className={`w-full px-4 py-4 rounded-xl border text-base text-gray-900 ${stateClasses} ${className}`}
        placeholderTextColor={placeholderTextColor ?? "#6B7280"}
        onFocus={(e) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        {...rest}
      />
    );
  },
);

FormInput.displayName = "FormInput";

export default FormInput;
